import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import { PostRegistroMaquinaTejido } from "../../services/maquinasTejido.services";
import ModalCharge from "../../modal/modalCharge";
import ModalUserTejido from "../../modal/user/modalUserTejido";
import LoadingSpinner from "../../loadingSpinner";
import { PostOrdenTejido } from "../../services/ordenTejido.services";
import ModalProductosTejido from "../../modal/producto/modalProductoTejido";
import MenuItem from '@mui/material/MenuItem';

const OrdenTejido = () => {
  const [isModalChargeOpen, setIsModalChargeOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalFuncionariosOpen, setModalFuncionariosOpen] = useState(false);
  const [modalProductoTejidoOpen, setModalProductosTejidoOpen] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [nombreFuncionario, setNombreFuncionario] = useState("");
  const [formikSetFieldValue, setFormikSetFieldValue] = useState(() => () => {});
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const { id_producto, cantidad, id_cliente } = values;

    const valuesToSend = {
        id_producto,
        cantidad,
        id_cliente,
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 3000));
      await PostOrdenTejido(valuesToSend);
      setRegistrationSuccess(true);
      resetForm();
      setNombreFuncionario(""); // Limpiar campo visual
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setIsLoading(false);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  return (
    <Box m="20px">
      <Header title="Registro Orden de Producción" subtitle="Registrar orden de producción de rollos" />
      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={() => setRegistrationSuccess(false)} />
      )}
      {registrationError && (
        <ModalError open={registrationError} onClose={() => setRegistrationError(false)} error={error} />
      )}

      {/* Modal de selección de operador */}
        <ModalUserTejido
            open={modalFuncionariosOpen}
            onClose={() => setModalFuncionariosOpen(false)}
            onSelectUsuario={(usuario) => {
            formikSetFieldValue("id_usuario", usuario.id);
            setNombreFuncionario(`${usuario.firstname} ${usuario.lastname}`);
            setModalFuncionariosOpen(false);
        }}
        />


      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
            id_producto: "",
            cantidad: "",
            descripcion: "",
            id_cliente: "",
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue
        }) => {
          setFormikSetFieldValue(() => setFieldValue); // guardar referencia usable fuera

          return (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Producto"
                  onClick={()=>setModalProductosTejidoOpen(true)}
                  InputProps={{ readOnly: true }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.descripcion}
                  name="id_producto"
                  error={!!touched.id_producto && !!errors.id_producto}
                  helperText={touched.id_producto && errors.id_producto}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Cantidad"
                  value={values.cantidad}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="cantidad"
                  sx={{ gridColumn: "span 2", cursor: "pointer" }}
                  helperText={touched.cantidad && errors.cantidad}
                  error={!!touched.cantidad && !!errors.cantidad}
                />
                <TextField
                    select
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Cliente"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.id_cliente}
                    name="id_cliente"
                    error={!!touched.id_cliente && !!errors.id_cliente}
                    helperText={touched.id_cliente && errors.id_cliente}
                    sx={{ gridColumn: "span 2" }}
                >
                    <MenuItem value={1}>Evoluaço</MenuItem>
                    <MenuItem value={2}>Sideragro</MenuItem>
                    <MenuItem value={3}>Interno</MenuItem>
                </TextField>
              </Box>

              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  sx={{
                    backgroundColor: "rgb(206, 220, 0)",
                    border: "none",
                    color: "black",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#bac609" },
                  }}
                  variant="contained"
                >
                  Registrar
                </Button>
              </Box>
              <ModalCharge isLoading={isLoading} />
                <ModalProductosTejido
                    open={modalProductoTejidoOpen}
                    onClose={() => setModalProductosTejidoOpen(false)}
                    onSelectProduct={(producto) => {
                      setFieldValue("id_producto", producto.id);         // el ID real del producto
                      setFieldValue("descripcion", producto.descripcion); // lo que verá el usuario
                      setModalProductosTejidoOpen(false); // cerrar modal
                    }}
                />

            </form>
          );
        }}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
    id_producto: yup.number().required("La orden de producción es requerida"),
    cantidad: 
    yup.
    number()
    .typeError("Tiene que ser un número")
    .positive("Tiene que ser positivo")
    .required("La cantidad es requerida"),
    id_cliente: yup.number().required("Debes ingresar el cliente")
});

export default OrdenTejido;
